import { FieldError } from '@/components/ui/field';
import { UploadTerminImage } from '@/domain/termine/components/TerminImage/UploadTerminImage';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';

export function ImageFormField({ form }: UpdateTermineFormProps) {
  return (
    <form.AppField name="terminBild">
      {(field) => (
        <div className="flex flex-col gap-1">
          <UploadTerminImage
            image={field.state.value ?? undefined}
            variant="sheet"
            markierung={form.getFieldValue('markierung')}
            className="text-neutrals-700"
            onFileSelect={(file) => {
              field.handleChange(
                file
                  ? { file, name: file.name, contentType: file.type }
                  : undefined,
              );
              field.handleBlur();
            }}
          />
          <form.Subscribe selector={(state) => [state.fieldMeta]}>
            {([fieldMeta]) => {
              const fileErrors = fieldMeta['terminBild.file']?.errors;
              return <FieldError errors={fileErrors} />;
            }}
          </form.Subscribe>
        </div>
      )}
    </form.AppField>
  );
}
